import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from '@env';

const domain = window.location.hostname;

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

	constructor(
		private titleService: Title
	) {	}

	ngOnInit() {
		this.titleService.setTitle(environment[environment.alias[domain]].app.title);
	}

}
